(function () {
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.card-share-button');
    if (!button) return;
    event.preventDefault();

    const url = button.dataset.shareUrl;
    const title = button.dataset.shareTitle;

    if (navigator.share) {
      navigator.share({ title, url }).catch(() => {});
      return;
    }

    try {
      await navigator.clipboard.writeText(url);
      const original = button.getAttribute('aria-label');
      button.setAttribute('aria-label', 'Link copied');
      button.classList.add('card-share-button--copied');
      window.setTimeout(() => {
        button.setAttribute('aria-label', original);
        button.classList.remove('card-share-button--copied');
      }, 1500);
    } catch (e) {
      // Clipboard API unavailable (e.g. insecure context) — nothing more we can do silently.
    }
  });
})();
